import Icon from '@/components/ui/AppIcon';

interface Capability {
  id: number;
  category: string;
  skills: string[];
  equipment: string[];
  icon: string;
}

interface TechnicalCapabilitiesProps {
  capabilities: Capability[];
}

export default function TechnicalCapabilities({ capabilities }: TechnicalCapabilitiesProps) {
  return (
    <section className="bg-card py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-headline font-bold text-primary mb-4">
            Technical Capabilities
          </h2>
          <p className="text-lg text-textSecondary max-w-3xl mx-auto">
            Comprehensive technical expertise and specialized equipment for mission-critical infrastructure projects
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {capabilities.map((capability) => (
            <div
              key={capability.id}
              className="bg-surface rounded-lg p-6 shadow-subtle hover:shadow-modal transition-shadow duration-300"
            >
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mr-4">
                  <Icon
                    name={capability.icon as any}
                    size={24}
                    className="text-primary-foreground"
                  />
                </div>
                <h3 className="text-xl font-headline font-bold text-textPrimary">
                  {capability.category}
                </h3>
              </div>

              <div className="mb-4">
                <h4 className="text-sm font-body font-semibold text-textPrimary mb-2">
                  Specialized Skills:
                </h4>
                <ul className="space-y-2">
                  {capability.skills.map((skill, index) => (
                    <li key={index} className="flex items-start">
                      <Icon
                        name="CheckCircleIcon"
                        size={18}
                        className="text-success mt-0.5 mr-2 flex-shrink-0"
                      />
                      <span className="text-sm text-textSecondary">{skill}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="text-sm font-body font-semibold text-textPrimary mb-2">
                  Equipment & Tools:
                </h4>
                <div className="flex flex-wrap gap-2">
                  {capability.equipment.map((item, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center px-3 py-1 rounded-full bg-card text-xs text-textSecondary border border-border"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}